
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24","fill":"#5f6368"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M480-344L240-584l56-56 184 184 184-184 56 56-240 240z"}})])
          )
        }
      }
    